import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'

/*
  O "Ver histórico" dos cards do Dashboard: os filtros e o gráfico mês a mês num Dialog. Fecha
  também com o clique fora, porque não há o que perder: o período escolhido fica no card.
*/
export default function HistoryDialog({ visible, title, onClose: handleClose, children }) {
  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='xl' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {children}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
